import {
  Boxes,
  LayoutDashboard,
  ListChecks,
  PackageCheck,
  Settings,
  Wallet
} from "lucide-react";
import type { SidebarLinkItem } from "./sidebar";

interface NavLinkItem extends SidebarLinkItem {
  /** Also offered as a quick link on the 404 page (see {@link QUICK_LINKS}). */
  quickLink?: boolean;
}

/**
 * The app shell's navigation, in sidebar order. Owned here, beside the sidebar
 * it feeds, so other surfaces that point at the same destinations (the 404
 * page's quick links) read the one list instead of repeating the hrefs.
 */
export const SIDEBAR_LINKS: NavLinkItem[] = [
  //   {
  //     label: "Home",
  //     to: "/",
  //     Icon: Home
  //   },
  {
    label: "Dashboard",
    to: "/",
    Icon: LayoutDashboard,
    quickLink: true
  },
  {
    label: "Orders",
    to: "/orders",
    Icon: PackageCheck,
    quickLink: true
  },
  // {
  //   label: "Shopping",
  //   to: "/shopping",
  //   Icon: Package
  // },
  {
    label: "Saved Lists",
    to: "/account/saved-lists",
    Icon: ListChecks,
    quickLink: true
  },
  {
    label: "My Stock",
    to: "/account/stock",
    Icon: Boxes,
    quickLink: true
  },
  {
    label: "Budgets",
    to: "/",
    Icon: Wallet,
    comingSoon: true
  },
  {
    label: "Settings",
    to: "/account",
    Icon: Settings
  }
];

/**
 * The sidebar's everyday destinations: the entries explicitly flagged
 * `quickLink`, in sidebar order. Opt-in rather than derived, so a new or
 * re-pointed sidebar entry never lands on the 404 page by accident. Settings
 * and the "coming soon" placeholder are deliberately not flagged.
 */
export const QUICK_LINKS: NavLinkItem[] = SIDEBAR_LINKS.filter(
  (link) => link.quickLink === true
);
